<template>
  <el-dialog title="地址信息" :visible.sync="innerVisible" custom-class="min-dialog address-dialog" center
             :close-on-click-modal="false"
             append-to-body open>
    <el-form :model="form" ref="form1" :rules="rules">
          <el-form-item label="粘贴解析" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="parseText" :rows="2" style="width:400px;vertical-align:top;"
                      placeholder="粘贴客服复制的文字，自动解析联系人/电话/省市区/地址，可手动修正"></el-input>
            <el-button type="primary" size="mini" style="margin-left:8px;vertical-align:top;"
                       @click="parseAddressText">解析并填入</el-button>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="区域" :label-width="formLabelWidth" prop="province">
                <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city"
                              @city="onChangeCity" :area="form.county" @area="onChangeArea"
                              :key="distpickerKey"></v-distpicker>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="详细地址" :label-width="formLabelWidth" prop="address">
            <el-input v-model="form.address" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="收货人" :label-width="formLabelWidth" prop="uname">
            <el-input v-model="form.uname" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="联系方式" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
                <el-form-item label="是否默认地址" :label-width="formLabelWidth" prop="defalut">
                  <el-radio-group v-model="form.defalut">
                    <el-radio :label="'1'">是</el-radio>
                    <el-radio :label="'0'">否</el-radio>
                  </el-radio-group>
                </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="排序" :label-width="formLabelWidth">
                <el-input v-model="form.sort" auto-complete="off" placeholder="排序值(越大越靠前，默认地址用最大)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData1">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

  import {attUUID} from '@/api/attachment';
  // 省市区字典（与 v-distpicker 同源，用于文本解析时按名称匹配）
  import provinceDict from '@/components/common/distpicker2/province.js';
  import cityDict from '@/components/common/distpicker2/city.js';
  import areaDict from '@/components/common/distpicker2/area.js';

  export default {
    name: "AddressEdit",
    data() {
      return {
        sex: '0',
        innerVisible: false,
        parseText: '',
        distpickerKey: 0,
        activeNames: ['1', '2', '3'],
        ad:{
          area:''
        },
        form: {  //表单数据
          unitguid:'',
          area:'',
          address:'',
          uname:'',
          defalut:'1',
          mobile:'',
          province:'',
          city:'',
          county:'',
          sort:'',
        },
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。

          sex: [],

        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          uname: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
          ],
          province:[
            {required: true, message: '请输入地址', trigger: 'blur'},
          ],
          address:[
            {required: true, message: '请输入地址', trigger: 'blur'},
          ]

        },

      }
    },

    props: ["unitguid"],

    methods: {
      showaddress(row) {
        this.parseText = '';
        this.distpickerKey = 0;
        if(row){
          this.form= Object.assign({},row) ;
        }else {
          this.form={};
        }
        // this.form.dguid = unitguid
        this.innerVisible = true
      },
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      },
      onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      },
      onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      //在文本中查找 names（含 code），from 位置之后最早出现的名字，返回 {name, code, index}；未找到返回 null
      findFirstRegion(list, str, from) {
        let best = null;
        for (let i = 0; i < list.length; i++) {
          const idx = str.indexOf(list[i].name, from);
          if (idx !== -1 && (!best || idx < best.index)) {
            best = {name: list[i].name, code: list[i].code, index: idx};
          }
        }
        return best;
      },
      //清理详细地址：去掉开头遗留的字段标签、残留标签词、结尾邮编、首尾分隔符
      cleanAddress(str) {
        let s = String(str || '');
        //反复去掉开头的字段标签（省份： 城市： 区县： 街道： 地址： 电话： 等）
        for (let i = 0; i < 12; i++) {
          const before = s;
          s = s.replace(/^([\s,，。;；、|:：()（）【】\[\]_-]*)(省份|城市|区县|县区|省市区|地区|街道|地址|收货地址|送货地址|详细地址|联系电话|联系方式|电话|手机|联系人|收货人|收件人|姓名)\s*[:：]?\s*/, '');
          if (s === before) break;
        }
        //去掉残留的字段标签词（已提取出联系人等信息后，这些词不应再出现在地址里）
        s = s.replace(/(联系电话|手机号码|手机号|联系方式|联系人|收货人|收件人|姓名|区县|县区|省份)\s*[:：]?\s*/g, '');
        //去掉结尾的邮编
        s = s.replace(/(邮编|邮政编码|邮编码)\s*[:：]?\s*\d{5,6}\s*$/, '');
        //清理首尾分隔符/空白
        s = s.replace(/^[\s,，。;；、|:：()（）【】\[\]_-]+/, '')
          .replace(/[\s,，。;；、|:：()（）【】\[\]_-]+$/, '');
        return s;
      },
      //粘贴文本智能解析：无固定格式，启发式提取 联系人/电话/省市区/详细地址，填入表单后可手动修正
      parseAddressText() {
        const t0 = String(this.parseText || '').trim();
        if (!t0) {
          this.$message({message: '请先粘贴地址文本', type: 'warning'});
          return;
        }
        let t = t0;
        const result = {uname: '', mobile: '', province: '', city: '', county: '', address: ''};
        //1. 电话（最可靠）：手机号优先，否则座机；正则带数字边界，避免匹配到订单号/日期片段中的数字
        let phoneRaw = '', phoneIndex = -1;
        let m1 = t.match(/(^|[^\d])(1[3-9]\d{9})([^\d]|$)/);
        if (m1) {
          phoneRaw = m1[2];
          phoneIndex = m1.index + m1[1].length;
        } else {
          const m2 = t.match(/(^|[^\d])(0\d{2,3}-?\d{7,8})([^\d]|$)/);
          if (m2) {
            phoneRaw = m2[2];
            phoneIndex = m2.index + m2[1].length;
          }
        }
        if (phoneRaw) result.mobile = phoneRaw.replace(/-/g, '');
        //2. 省市区（字典匹配）
        let provinceMatch = null, cityMatch = null, areaMatch = null, regionEnd = -1;
        //省：所有省名中最先出现者
        const provList = [];
        for (const code in provinceDict) provList.push({name: provinceDict[code], code: code});
        provinceMatch = this.findFirstRegion(provList, t, 0);
        if (provinceMatch) {
          result.province = provinceMatch.name;
          //市：优先匹配该省下的市名（排除跨省同名）
          const cityMap = cityDict[provinceMatch.code] || {};
          const cityList = [];
          for (const code in cityMap) cityList.push({name: cityMap[code], code: code});
          cityMatch = this.findFirstRegion(cityList, t, provinceMatch.index + provinceMatch.name.length);
          //直辖市（北京市/天津市/上海市/重庆市）等单市省份：省名即市名，文本中不会再出现第二段同名市
          if (!cityMatch) {
            const single = cityList.length === 1 ? cityList[0] : cityList.filter(c => c.name === provinceMatch.name)[0];
            if (single) cityMatch = {name: single.name, code: single.code, index: -1};
          }
          if (cityMatch) result.city = cityMatch.name;
        } else {
          //省未匹配（如文本只写了市/区）：全局市名兜底，再反推省
          for (const pcode in cityDict) {
            const cityMap = cityDict[pcode];
            for (const code in cityMap) {
              const idx = t.indexOf(cityMap[code]);
              if (idx !== -1 && (!cityMatch || idx < cityMatch.index)) {
                cityMatch = {name: cityMap[code], code: code, index: idx};
              }
            }
          }
          if (cityMatch) {
            const provCode = String(cityMatch.code).slice(0, 2) + '0000';
            if (provinceDict[provCode]) {
              provinceMatch = {name: provinceDict[provCode], code: provCode, index: -1};
              result.province = provinceMatch.name;
              result.city = cityMatch.name;
            }
          }
        }
        //区/县：限定在该市的区列表内匹配（避免各市同名区 like 朝阳区/西湖区 错配）
        if (cityMatch) {
          const areaMap = areaDict[cityMatch.code] || {};
          const areaList = [];
          for (const code in areaMap) areaList.push({name: areaMap[code], code: code});
          const areaFrom = cityMatch.index >= 0 ? cityMatch.index + cityMatch.name.length
            : (provinceMatch && provinceMatch.index >= 0 ? provinceMatch.index + provinceMatch.name.length : 0);
          areaMatch = this.findFirstRegion(areaList, t, areaFrom);
          if (areaMatch) result.county = areaMatch.name;
          //记录区域在原文中的结束位置（详细地址提取用）
          if (areaMatch) {
            regionEnd = areaMatch.index + areaMatch.name.length;
          } else if (cityMatch.index >= 0) {
            regionEnd = cityMatch.index + cityMatch.name.length;
          } else if (provinceMatch && provinceMatch.index >= 0) {
            regionEnd = provinceMatch.index + provinceMatch.name.length;
          }
        } else if (provinceMatch && provinceMatch.index >= 0) {
          regionEnd = provinceMatch.index + provinceMatch.name.length;
        }
        //3. 联系人（启发式）
        const nameRe = /(联系人|收货人|收件人|姓名|联系人姓名|客户姓名)\s*[:：]?\s*([一-龥]{2,4})/;
        const nameMatch = t.match(nameRe);
        let nameLabel = '';
        if (nameMatch) {
          result.uname = nameMatch[2];
          nameLabel = nameMatch[0];
        } else if (phoneIndex >= 0) {
          //电话之前、以分隔符隔开的最后一段连续中文（2-4字）作为联系人
          const pre = t0.slice(0, phoneIndex);
          const preMatch = pre.match(/(^|[\s,，。;；、|:：()（）【】\[\]_-]+)([一-龥]{2,4})\s*$/);
          if (preMatch) result.uname = preMatch[2];
        }
        if (!result.uname) {
          //剩余文本开头第一段连续中文
          const leadMatch = t.match(/^[\s,，。;；、|:：()（）【】\[\]_-]*([一-龥]{2,4})/);
          if (leadMatch) result.uname = leadMatch[1];
        }
        //4. 从文本移除：联系人标签块、省市区名、电话（含"电话：/tel"等前缀）
        if (nameLabel) t = t.replace(nameLabel, '');
        if (result.uname) t = t.replace(result.uname, '');
        [result.province, result.city, result.county].forEach(n => {
          if (n) t = t.replace(n, '');
        });
        if (phoneRaw) {
          const phoneEsc = phoneRaw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const labelRe = new RegExp('(联系电话|手机号码|手机号|电话号码|电话|手机|座机|tel|Tel|TEL)\\s*[:：\\-—]?\\s*' + phoneEsc);
          const lm = t.match(labelRe);
          t = lm ? t.replace(lm[0], '') : t.replace(phoneEsc, '');
        }
        //5. 详细地址：优先取省市区结束位置之后的原文（区域名是地址部分的最强锚点），再做清理
        let address = '';
        if (regionEnd >= 0) {
          address = t0.slice(regionEnd);
          if (result.uname) address = address.replace(result.uname, '');
          if (phoneRaw) {
            const phoneEsc = phoneRaw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const labelRe = new RegExp('(联系电话|手机号码|手机号|电话号码|电话|手机|座机)\\s*[:：\\-—]?\\s*' + phoneEsc);
            const lm = address.match(labelRe);
            address = lm ? address.replace(lm[0], '') : address.replace(phoneEsc, '');
          }
        }
        address = this.cleanAddress(address);
        if (address.length < 4) {
          //原始区切片过短：用移除省市区/电话后的剩余文本兜底
          const later = this.cleanAddress(t);
          if (later.length > address.length) address = later;
        }
        result.address = address;
        //6. 填入表单并刷新省市区组件（:key 强制重渲染，读取已解析的省市区）
        this.form = Object.assign({}, this.form, {
          uname: result.uname,
          mobile: result.mobile,
          province: result.province,
          city: result.city,
          county: result.county,
          address: result.address
        });
        this.distpickerKey++;
        //7. 反馈：未识别字段提示手动补充
        const miss = [];
        if (!result.province) miss.push('省');
        if (!result.city) miss.push('市');
        if (!result.county) miss.push('区/县');
        if (!result.uname) miss.push('联系人');
        if (!result.mobile) miss.push('电话');
        if (!result.address) miss.push('详细地址');
        if (miss.length) {
          this.$message({message: '已自动填入，未识别：' + miss.join('、') + '，请手动补充', type: 'warning'});
        } else {
          this.$message({message: '已自动填入，请核对后保存', type: 'success'});
        }
      },

      saveData1() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            if(!this.form.unitguid){
              this.form.unitguid=attUUID();
            }
            this.ad=this.form;
            this.$emit('addresss',this.ad);
            this.innerVisible = false;
          }
        })

      },
      initAddressData(uguid) {
        // getContactorDetail({uguid: uguid}).then(response => {
        //   // this.form = response.data.obj;
        // })
      },
      initFormContactor() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },

  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }
</style>

<style>
  /* 弹窗加高：全局 .min-dialog 固定高度 500px（300px+首部），加"粘贴解析"控件后内容变高，
     沿用 min-dialog 复用其背景样式，叠 address-dialog 独立抬高高度，不外溢到其他页面；
     scoped 无法命中 append-to-body 移到 body 下的 .el-dialog 根节点，故用非 scoped + 复合选择器提高优先级 */
  .min-dialog.address-dialog {
    height: 650px !important;
    margin-top: calc(50vh - 325px) !important;
  }
  .min-dialog.address-dialog .el-dialog__body {
    height: 500px !important;
    padding-bottom: 10px !important;
    overflow-y: auto; /* 内容超出时弹窗内部滚动，不出页面级滚动条 */
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/AddressEdit.vue